import React from 'react'
import Layout from '../../components/Layout'
import BlogRoll from '../../components/BlogRoll'
import './blog.css'

const BlogIndexPage = () => {
  return (
    <Layout>
      <div className="blog-page">
        <div className="blog-hero">
          <div className="blog-hero-content">
            <h1 className="blog-hero-title">Technical Articles</h1>
            <p className="blog-hero-description">
              Sharing insights and knowledge about software engineering, web development, and modern technologies.
            </p>
          </div>
        </div>
        <div className="blog-content">
          <BlogRoll />
        </div>
      </div>
    </Layout>
  )
}

export default BlogIndexPage;